const comments = [
  {
    name: '追剧小达人',
    text: '用了两年多了，7777影院真的良心。资源全、更新快、画质好，最关键是免费！推荐给了身边所有朋友，大家现在都在用。',
    date: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20portrait%20avatar%20style%2C%20young%20Asian%20person%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%20in%20warm%20cream%20tone%2C%20professional%20headshot%20composition&width=80&height=80&seq=avatar-user1-2026&orientation=squarish',
  },
  {
    name: '电影迷阿杰',
    text: '作为一个重度电影爱好者，7777影院的片库深度让我惊喜。很多小众文艺片和经典老片都能找到高清版本，CDN加速确实快，4K都不卡。',
    date: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20casual%20portrait%20avatar%2C%20young%20man%20with%20glasses%20smiling%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20cream%20background%2C%20friendly%20expression%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-user2-2026&orientation=squarish',
  },
  {
    name: '午夜追剧人',
    text: '每天下班就靠7777影院续命了，更新速度和播出平台完全同步，再也不用到处找资源。手机端体验也很棒，躺着追剧太舒服了。',
    date: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20avatar%20style%2C%20young%20woman%20with%20natural%20smile%2C%20soft%20warm%20lighting%2C%20clean%20cream%20minimal%20background%2C%20casual%20professional%20headshot%20composition&width=80&height=80&seq=avatar-user3-2026&orientation=squarish',
  },
  {
    name: '剧荒拯救者',
    text: '以前总是剧荒不知道看什么，7777影院的推荐和榜单真的很精准。热门话题区也经常能发现好片，已经成了我的日常打开网站之一。',
    date: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20portrait%20avatar%20with%20warm%20tone%2C%20young%20Asian%20woman%20with%20gentle%20smile%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20composition&width=80&height=80&seq=avatar-user4-2026&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            用户心声
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            来自真实用户的使用感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200 rounded-xl p-6"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    width="44"
                    height="44"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-sm font-semibold text-foreground-900">
                      {comment.name}
                    </h3>
                    <span className="text-xs text-foreground-500">
                      {comment.date}
                    </span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[...Array(5)].map((_, j) => (
                      <div key={j} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-xs"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {comment.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}